import { useFeatureAvailable, Feature } from 'App/components/hooks/featureHelper';
import { useSelf } from 'App/components/hooks/appHooks';

export default function useFindProspectsAllowed() {
	const hasSoliditet = useFeatureAvailable(Feature.SOLIDITET);
	const self = useSelf();
	const hasAccess = !!(self?.administrator || self?.userParams?.multiSoliditetAccess);
	return hasSoliditet && hasAccess;
}
